// extracted by mini-css-extract-plugin
module.exports = {"link":"AccessibilityJumpNavigation_link__Z9EHw"};